import axios from 'axios';
import { baseURL } from './types';

// Action Types
export const TRANSACTION_LIST_REQUEST = 'TRANSACTION_LIST_REQUEST';
export const TRANSACTION_LIST_SUCCESS = 'TRANSACTION_LIST_SUCCESS';
export const TRANSACTION_LIST_FAIL = 'TRANSACTION_LIST_FAIL';

const API_URL = `${baseURL}/api`;

export const listAllTransactions = () => async (dispatch) => {
    try {
      dispatch({ type: TRANSACTION_LIST_REQUEST });
  
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      };
  
      const { data } = await axios.post(
        `${baseURL}/api/appointmentPaymentTransactions/getAll`,
        {},
        config
      );
  
      const transactions = Array.isArray(data.data) ? data.data : [];
  
      dispatch({
        type: TRANSACTION_LIST_SUCCESS,
        payload: transactions,
      });
      
      return transactions; // ✅ RETURN THE DATA
  
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      dispatch({
        type: TRANSACTION_LIST_FAIL,
        payload: message,
      });
      return []; // ✅ RETURN EMPTY ARRAY ON ERROR
    }
  };